module.exports = __webpack_public_path__ + "media/team_admin/makeAdmin-88372f27.png";